import React from 'react';
import { Modal, Row, Col, Card } from 'antd';
import { FileTextOutlined, CheckSquareOutlined, EditOutlined } from '@ant-design/icons';

// Bloque foto: diferido al sub-incremento 3b (necesita esquema de keys S3 +
// preview/persistencia + wiring al PDF). Por ahora: texto, checklist, firma.
const OPTS = [
  { type: 'text', label: 'Texto', icon: <FileTextOutlined /> },
  { type: 'checklist', label: 'Checklist', icon: <CheckSquareOutlined /> },
  { type: 'signatures', label: 'Firma', icon: <EditOutlined /> },
];

function AgregarBloqueModal({ open, onPick, onClose }) {
  return (
    <Modal open={open} onCancel={onClose} footer={null} title="Agregar bloque">
      <Row gutter={[12, 12]}>
        {OPTS.map((o) => (
          <Col span={8} key={o.type}>
            <Card hoverable onClick={() => onPick(o.type)} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28 }}>{o.icon}</div>
              <div style={{ marginTop: 6 }}>{o.label}</div>
            </Card>
          </Col>
        ))}
      </Row>
    </Modal>
  );
}

export default AgregarBloqueModal;
